import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterDropdown'
})
export class FilterDropdownPipe implements PipeTransform {

  /**
   * Order an array by key
   * @param {any[]} array
   * @param {number} value
   * @returns {any}
   */
  transform(array: any[], value: number): any {
    if (!array || !value) {
      return array;
  }
  return array.filter(item => item.id != value);
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/filter-dropdown-pipe.ts